import api from "./api";
import endpoints from "./endpoints";
import { IHealthCheckModel, IVersionResponse } from "@medapro-types/services/healthChecks";

export default {
  getVersion: async function (): Promise<IVersionResponse> {
    const response = await api.get(endpoints.healthChecks.version);
    return response.data;
  },
  getDatabaseStatus: async function (): Promise<IHealthCheckModel> {
    const response = await api.get(endpoints.healthChecks.database.status);
    return response.data;
  },
  getDatabaseCompatibility: async function (): Promise<IHealthCheckModel> {
    const response = await api.get(endpoints.healthChecks.database.compatibility);
    return response.data;
  },
  getDatabaseScriptStatus: async function (): Promise<IHealthCheckModel> {
    const response = await api.get(endpoints.healthChecks.database.scripts);
    return response.data;
  },
  getMediaPathStatus: async function (): Promise<IHealthCheckModel> {
    const response = await api.get(endpoints.healthChecks.media);
    return response.data;
  }
};
